// src/components/Layout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavigation from './Navigation/AppNavigation';

function Layout({ darkMode, onToggleTheme, onLogout }) {
  return (
    <AppNavigation
      darkMode={darkMode}
      onToggleTheme={onToggleTheme}
      onLogout={onLogout}
    >
      <Outlet />
    </AppNavigation>
  );
}

export default Layout;
